import Icon from '../components/Icon.vue'

Icon.register({
  mars: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M372 64c6.6 0 12 5.4 12 12v79c0 10.7-12.9 16.1-20.5 8.5l-16.9-16.9-80.7 80.7c14 22.2 22.1 48.5 22.1 76.7 0 79.5-64.5 144-144 144s-144-64.5-144-144 64.5-144 144-144c28.2 0 54.5 8.1 76.7 22.1l80.7-80.7-16.9-16.9c-7.5-7.6-2.2-20.5 8.5-20.5h79zM144 384c44.1 0 80-35.9 80-80s-35.9-80-80-80-80 35.9-80 80 35.9 80 80 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mars.js
// module id = 1554
// module chunks = 0